import React, { Component } from 'react'
import { translate } from 'react-i18next'
import A from './A'

class VCTable extends Component {
  urlToButton = text => {
    if (text.match(/^http[s]?:\/\/.+\.(pdf|pptx|zip)$/i))
      return <A className='btn' href={text} target='_blank'>{this.props.t('lbl.download')}</A>
    if (text.match(/^http[s]?:\/\/.+/i))
      return <A href={text}>{text}</A>
    return text
  }
  removeStyles = text => {
    if (typeof text === 'string') {
        text = text.replace('[align-center]', '');
        text = text.replace('[align-left]', '');
        text = text.replace('[align-right]', '');
    }
    return text
  }
  convertStyles = text => {
    let style = {};
    if (text.includes("[align-center]"))
        style = {textAlign: 'center'};
    if (text.includes("[align-left]"))
        style = {textAlign: 'left'};
    if (text.includes("[align-right]"))
        style = {textAlign: 'right'};
    return style
  }
  render() {
    if (!this.props.children.props.element[0] || this.props.children.props.element[0].data.split('|').length === 0) {
      return null
    }
    const tHead = this.props.children.props.element[0].data.split('|')[0].split(',')
    const tBody = this.props.children.props.element[0].data.split('|').slice(1)
    return (
      <table className={this.props.className}>
        <thead>
          {/* {this.props.children.props.element[0] && this.props.children.props.element[0].data.split('|').slice(0, 1).map((row, rowKey) => (
            <tr key={rowKey}>{row.split(',').map((col, colKey) => (
              <td key={colKey}>{decodeURIComponent(col)}</td>
            ))}</tr>
          ))} */}
          <tr>
            {tHead.map((col, colKey) => (
            <td key={colKey}>{decodeURIComponent(col)}</td>
            ))}
          </tr>
        </thead>
        <tbody>
          {/* {this.props.children.props.element[0] && this.props.children.props.element[0].data.split('|').slice(1).map((row, rowKey) => (
            <tr key={rowKey}>{row.split(',').map((col, colKey) => (
              <td data-title={tHead[colKey]} key={colKey}>{decodeURIComponent(col)}</td>
            ))}</tr>
          ))} */}
          {tBody.map((row, rowKey) => (
            <tr key={rowKey}>{row.split(',').map((col, colKey) => (
              <td data-title={decodeURIComponent(tHead[colKey])} key={colKey} style={this.convertStyles(decodeURIComponent(col))}>{this.removeStyles(this.urlToButton(decodeURIComponent(col)))}</td>
            ))}</tr>
          ))}
        </tbody>
      </table>
    )
  }
}

export default translate()(VCTable)


// WEBPACK FOOTER //
// ./src/components/VCTable.js